import React, { useState, useEffect, useRef } from 'react';
import Papa from 'papaparse';
import '../ProductList.css';
import AdultSlider from './AdultSlider';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { GoMoveToTop } from "react-icons/go";
import { images } from './axAdult';
import { productDb } from '../firebaseProducts';
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
const AdultsBlanks = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [percentage, setPercentage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
    const [aspectRatio, setAspectRatio] = useState(75); // default 4:3
  const [searchTerm, setSearchTerm] = useState('');
  const [color, setColor] = useState('');

  const [sliderValue, setSliderValue] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedTags, setSelectedTags] = useState({
    "Women": false, "Men": false, "T-Shirts": false, "L/Sleeve": false,
    "V-Neck": false, "Tanks": false, "Cardigans": false, Shirts: false,
    Hoodies: false, "Sweatshirts": false, 'Full Zip': false, Jackets: false,
    Polos: false
  });
  const [filterMode, setFilterMode] = useState("AND"); // "AND" or "OR"
  const itemsPerPage = 12;
  const navigate = useNavigate();
  const videoRef = useRef(null);
  useEffect(() => {
    // console.log("1")
    if (images.length > 0) {
      const img = new Image();
      img.src = images[0].src;
      img.onload = () => {
        setAspectRatio((img.height / img.width) * 100);
      };
    }
  }, [images]);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);
  const vendorsToExclude = [
    "Brooks Brothers", "New Era", "Outdoor Research", "The North Face",
    "Carhartt", "Nike", "Stanley/Stella", "Tommy Bahama", "Cotopaxi",
    "OGIO", "tentree", "Travis Mathew", "Eddie Bauer"
  ];


  const loadFirestoreData = async () => {
    try {
      // console.log("🚀 Fetching products from Firestore…");

      const querySnapshot = await getDocs(collection(productDb, "adult-list-menu"));
      // console.log("📦 QuerySnapshot size:", querySnapshot.size);

      const today = new Date();

      const parsedProducts = querySnapshot.docs
        .map((doc, index) => {
          const data = doc.data();

          const parseDate = (dateStr) => {
            if (!dateStr) return null;

            if (dateStr instanceof Date) return dateStr;

            if (dateStr.toDate) return dateStr.toDate();

            if (typeof dateStr === "string") {
              if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
                const [year, month, day] = dateStr.split("-").map(Number);
                return new Date(year, month - 1, day);
              }

              if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) {
                const [month, day, year] = dateStr.split("/").map(Number);
                return new Date(year, month - 1, day);
              }
            }

            return new Date(dateStr); // fallback
          };

          const endSaleDate = parseDate(data.endSale);

          const isOnSale = endSaleDate && endSaleDate >= today;
      const price = Math.round((parseFloat(data.Price) + 5) * 100) / 100;
const salePrice = Math.round((parseFloat(data.salePrice) + 5) * 100) / 100;
          let discountPercentage = 0;
          if (price > 0 && salePrice > 0 && salePrice < price) {
            discountPercentage = Math.round(((price - salePrice) / price) * 100);
          }
const getFirstValid = (...values) => {
  return values.find(v => v && v.toString().trim() !== "");
};
          return {
            Handle: data.Title2,
            ColorVal: data.Color,
            Size: data.AVAILABLE_SIZES,
            DefaultImageSrc: data.img || data.model,
            HoverImageSrc: getFirstValid(data.BACK_FLAT, data.BACK_FLAT, data.SIDE_MODEL, data.img, data.model),
            Price: price,
            Description: data.Body,
            Style: data.Style,
            SalePrice: salePrice,
            DiscountPercentage: discountPercentage,
            EndSale: endSaleDate,
            Tags: data.Tags
              ? Array.isArray(data.Tags)
                ? data.Tags
                : data.Tags.split(",").map(t => t.trim())
              : [],
            isOnSale,
            Vendor: data.Vendor || "",   // 👈 Add Vendor to check against exclusion list
            Id: doc.id,
          };
        })
        .filter(product => !vendorsToExclude.includes(product.Vendor)); // ❗️Exclude specific vendors here

      setProducts(parsedProducts);
      // setFilteredProducts(parsedProducts);
      setLoading(false);
    } catch (err) {
      console.error("❌ Error fetching Firestore data:", err);
      setError(err.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    loadFirestoreData();
  }, []);

  const handleAddToCart = (product) => {
    navigate(`/product-adult/${product.Style}`);
  };

  useEffect(() => {
    let updatedProducts = [...products];

    if (color) {
      updatedProducts = updatedProducts.filter(product =>
        product.ColorVal.split(',').some(c => c.trim().toLowerCase().includes(color.toLowerCase()))
      );
    }

    const selectedTagKeys = Object.keys(selectedTags).filter(tag => selectedTags[tag]);
    if (selectedTagKeys.length > 0) {
      updatedProducts = updatedProducts.filter((product) =>
        filterMode === "AND"
          ? selectedTagKeys.every((tag) => product.Tags.includes(tag))
          : selectedTagKeys.some((tag) => product.Tags.includes(tag))
      );
    }

if (searchTerm) {
  updatedProducts = updatedProducts.filter(product => {
    const handle = product?.Handle?.toLowerCase() || "";
    const desc = product?.Description?.toLowerCase() || "";
    return (
      handle.includes(searchTerm.toLowerCase()) ||
      desc.includes(searchTerm.toLowerCase())
    );
  });
}

    const maxPrice = Math.max(...products.map(p => p.Price));
    const minPrice = Math.min(...products.map(p => p.Price));
    const targetPrice = minPrice + ((maxPrice - minPrice) * sliderValue) / 100;
    updatedProducts.sort((a, b) => {
      const diffA = Math.abs(a.Price - targetPrice);
      const diffB = Math.abs(b.Price - targetPrice);
      return diffA - diffB || a.Price - b.Price;
    });

    setFilteredProducts(updatedProducts);
  }, [products, selectedTags, searchTerm, sliderValue, color, filterMode]);

  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleTagChange = (e) => {
    setSelectedTags((prevTags) => ({
      ...prevTags,
      [e.target.name]: e.target.checked,
    }));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  if (loading) return <span className="loader"></span>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  // return (
  //   <>
  //     <div className="product-list-container" id="product-container">
  //       <div className="sidebar">
  //         <div className="sidebar-content">
  //           <div className="slider-container" style={{ marginLeft: -5, alignItems: 'center', width: "100%" }}>
  //             <AdultSlider width={"100%"} height={130} />
  //           </div>

  //           <div className="search-box">
  //             <h6 style={{ marginTop: -15, marginLeft: 5 }}>Categories</h6>
  //             <input
  //               type="text"
  //               style={{ fontSize: 8 }}
  //               value={searchTerm}
  //               onChange={handleSearchChange}
  //               placeholder="Search by name..."
  //             />
  //           </div>

  //           <div className="checkbox-filters">
  //             {Object.keys(selectedTags).map(tag => (
  //               <label key={tag}>
  //                 <input
  //                   type="checkbox"
  //                   name={tag}
  //                   checked={selectedTags[tag]}
  //                   onChange={handleTagChange}
  //                 />
  //                 {tag}
  //               </label>
  //             ))}
  //           </div>
  //         </div>

  //         <hr style={{ marginTop: -20, marginBottom: 0 }} />
  //         <div className="slider-container" style={{ textAlign: "center" }}>
  //           <label htmlFor="price-slider">Sort by Price</label>
  //           <input
  //             type="range"
  //             id="price-slider"
  //             min="0"
  //             max="100"
  //             // value={sliderValue}
  //             onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
  //           />
  //           <div className="labels" style={{ marginBottom: -15 }}>
  //             <span className="low">$5</span>
  //             <span className="high">$280</span>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="product-grid">
  //         {currentProducts.length > 0 ? (
  //           currentProducts.map((product, index) => (

  //             <div key={index} className="product-card" onClick={() => handleAddToCart(product)}>
  //               {product.isOnSale && (
  //                 <div className="sale-badge">{product.DiscountPercentage}% OFF</div>
  //               )}
  //               <div className="image-container">
  //                 <a href={`/product-adult/${product.Style}`} style={{ textDecoration: "none", color: "black" }}>
  //                   <img
  //                     src={product.DefaultImageSrc}
  //                     alt={product.Handle}
  //                     className="product-image default-image"
  //                   />
  //                   <img
  //                     src={product.HoverImageSrc}
  //                     alt={`${product.Handle} Hover`}
  //                     className="product-image hover-image"
  //                   />
  //                 </a>
  //               </div>
  //               <div className="product-details">
  //                 <h3 className="product-handle">{product.Handle}</h3>
  //                 {/* <p className="product-price">Price: From ${product.Price}</p> */}

  //                 <div className="product-price">
  //                   Price: From{" "}
  //                   {product.SalePrice > 0 && product.SalePrice < product.Price ? (
  //                     <>
  //                       <p className="product-price" style={{ textDecoration: 'line-through', color: 'grey' }}>${product.Price}</p>{" "}
  //                       <p className="text-red-600 font-bold">${product.SalePrice}</p>
  //                     </>
  //                   ) : (
  //                     <> ${product.Price}</>
  //                   )}
  //                 </div>

  //               </div>
  //               <div className="product-details2">
  //                 {product.Size}
  //               </div>
  //             </div>

  //           ))
  //         ) : (
  //           <p>No products available.</p>
  //         )}
  //       </div>
  //     </div>

  //     <div className="pagination">
  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(1)}
  //         disabled={currentPage === 1}
  //       >
  //         <img
  //           src="/images/assets/arrowFirs.png"
  //           style={{ maxWidth: 35, marginRight: -50 }}
  //           alt="First"
  //         />
  //       </button>

  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(currentPage - 1)}
  //         disabled={currentPage === 1}
  //       >
  //         <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
  //       </button>

  //       <span style={{ marginLeft: -10 }}>
  //         Page {currentPage} of {totalPages}
  //       </span>

  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(currentPage + 1)}
  //         disabled={currentPage === totalPages}
  //       >
  //         <img src="/right-arrow.png" style={{ maxWidth: 35, marginLeft: -15 }} alt="Next" />
  //       </button>

  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(totalPages)}
  //         disabled={currentPage === totalPages}
  //       >
  //         <img
  //           src="/images/assets/arrowLast.png"
  //           style={{ maxWidth: 35, marginLeft: -50 }}
  //           alt="Last"
  //         />
  //       </button>
  //     </div>
  //     <div>
  //       <a
  //         href="#product-container"
  //         style={{ textDecoration: "none", color: "black" }}
  //       >
  //         <p style={{ fontSize: "30px", fontWeight: "bold" }}>
  //           <GoMoveToTop />
  //         </p>
  //         <p style={{ marginTop: -25 }}>Top</p>
  //       </a>
  //     </div>
  //   </>
  // );
   return (
      <>
      <div id="top"></div>
        <div className="product-list-container" id="product-container">
          {/* Sidebar */}
          <div className="sidebar">
            <div className="sidebar-content">
              {/* Slider */}
              <div
                className="slider-container"
                style={{
                  maxWidth: 250,
                  width: "100%",
                  position: "relative",
                  paddingTop: `${aspectRatio}%`,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  }}
                >
                  <AdultSlider width="100%" height="100%" />
                </div>
              </div>
  
              {/* Search */}
              <div className="search-box">
                <h6 style={{ marginTop: -10, marginLeft: 5 }}>Categories</h6>
                <input
                  type="text"
                  // style={{ fontSize: 8 }}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Search by name..."
                />
              </div>
  
              {/* Filters */}
          <div className="checkbox-filters">
              {Object.keys(selectedTags).map((tag) => (
                <label key={tag}>
                  <input
                    type="checkbox"
                    name={tag}
                    checked={selectedTags[tag]}
                    onChange={handleTagChange}
                  />
                  {tag}
                </label>
              ))}
              <hr style={{ marginTop: 10, marginBottom: 5 }} />
              <div className="filter-mode-toggle">
                <label>
                  <input
                    type="radio"
                    name="filterMode"
                    value="AND"
                    checked={filterMode === "AND"}
                    onChange={(e) => setFilterMode(e.target.value)}
                  />
                  Match all
                </label>
                <label>
                  <input
                    type="radio"
                    name="filterMode"
                    value="OR"
                    checked={filterMode === "OR"}
                    onChange={(e) => setFilterMode(e.target.value)}
                  />
                  Match any
                </label>
              </div>
            </div>
            </div>
  
            <hr style={{ marginTop: -20, marginBottom: 0 }} />
  
            {/* Price Slider */}
            <div className="slider-container text-center">
              <label htmlFor="price-slider">Sort by Price</label>
              <input
                type="range"
                id="price-slider"
                min="0"
                max="100"
                value={sliderValue}
                onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
              />
              <div className="labels" style={{ marginBottom: -15 }}>
                <span className="low">$5</span>
                <span className="high">$280</span>
              </div>
            </div>
          </div>
  
          {/* Product Grid */}
          <div className="product-grid">
            {currentProducts.length > 0 ? (
              currentProducts.map((product, index) => (
                <div
                  key={index}
                  className="product-card"
                  onClick={() => handleAddToCart(product)}
                >
                  {product.isOnSale && (
                    <div className="sale-badge">
                      {product.DiscountPercentage}% OFF
                    </div>
                  )}
  
                  <div className="image-container">
                    <Link
                      to={`/product-adult/${product.Style}`}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <img
                        src={product.DefaultImageSrc}
                        alt={product.Handle}
                        className="product-image default-image"
                      />
                      <img
                        src={product.HoverImageSrc}
                        alt={`${product.Handle} Hover`}
                        className="product-image hover-image"
                      />
                    </Link>
                  </div>
  
                  <div className="product-details">
                    <h3 className="product-handle">{product.Handle}</h3>
  
                    <div className="product-price">
                      Price: From{" "}
                      {product.SalePrice > 0 &&
                      product.SalePrice < product.Price ? (
                        <>
                          <p
                            className="line-through text-gray-500"
                            style={{ display: "inline", marginRight: 8 }}
                          >
                            ${(product.Price).toFixed(2)}
                          </p>
                          <p className="text-red-600 font-bold inline">
                            ${(product.SalePrice).toFixed(2)}
                          </p>
                        </>
                      ) : (
                        <> ${(product.Price).toFixed(2)}</>
                      )}
                    </div>
                  </div>
  
                  <div className="product-details2">{product.Size}</div>
                </div>
              ))
            ) : (
                <img
            style={{ width: 200, marginTop: 10 }}
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925292/my_uploads/wyd702qpywbgad4p7xqk.jpg"
            alt="No products found"
          />
            )}
          </div>
        </div>
  
        {/* Pagination */}
        <div className="pagination">
          <button
            style={{ backgroundColor: "white" }}
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <img
              src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925250/my_uploads/o7m7damek0k2zanyyhcb.png"
              style={{ maxWidth: 35, marginRight: -50 }}
              alt="First"
            />
          </button>
  
          <button
            style={{ backgroundColor: "white" }}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
          </button>
  
          <span style={{ marginLeft: -10 }}>
            Page {currentPage} of {totalPages}
          </span>
  
          <button
            style={{ backgroundColor: "white" }}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <img
              src="/right-arrow.png"
              style={{ maxWidth: 35, marginLeft: -15 }}
              alt="Next"
            />
          </button>
  
          <button
            style={{ backgroundColor: "white" }}
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            <img
              src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925251/my_uploads/ocislq4muj6wqc5aks2k.png"
              style={{ maxWidth: 35, marginLeft: -50 }}
              alt="Last"
            />
          </button>
        </div>
  
   <div>
                    <a
                        href="#top"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <p style={{ fontSize: "30px", fontWeight: "bold" }}>
                          <GoMoveToTop />
                        </p>
                        <p style={{ marginTop: -25 }}>Top</p>
                      </a>
                    </div>
      </>
    );
};

export default AdultsBlanks;
